import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const LESSON_TYPE_ICONS = {
  video: 'PlayCircle',
  text: 'FileText',
  pdf: 'File',
  external: 'Link',
  live: 'Video',
  quiz: 'ListChecks',
};

const LessonNavigation = ({
  currentLesson,
  modules,
  onLessonChange,
  onPrevious,
  onNext,
  hasPrevious,
  hasNext,
  totalLessons,
  completedCount,
}) => {
  const percent = totalLessons > 0 ? Math.round((completedCount / totalLessons) * 100) : 0;

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={onPrevious}
          disabled={!hasPrevious}
          iconName="ChevronLeft"
          iconPosition="left"
          className="flex-1"
        >
          Previous
        </Button>
        <Button
          variant="default"
          size="sm"
          onClick={onNext}
          disabled={!hasNext}
          iconName="ChevronRight"
          iconPosition="right"
          className="flex-1"
        >
          Next
        </Button>
      </div>

      <div className="bg-white/70 backdrop-blur-xl rounded-2xl border border-white/40 shadow-sm overflow-hidden">
        <div className="p-5 border-b border-border/60">
          <div className="flex items-center justify-between mb-3">
            <h3 className="text-sm font-semibold text-foreground tracking-tight">Course Progress</h3>
            <span className="text-xs font-medium text-muted-foreground">
              {completedCount}<span className="text-muted-foreground/50">/{totalLessons}</span>
            </span>
          </div>
          <div className="w-full bg-muted/70 rounded-full h-1.5 overflow-hidden">
            <div
              className="bg-accent h-full rounded-full transition-all duration-500 ease-out"
              style={{ width: `${percent}%` }}
            />
          </div>
        </div>

        <div className="max-h-[28rem] overflow-y-auto p-2">
          {modules?.map((module, mIdx) => (
            <div key={module?.id} className={mIdx > 0 ? 'mt-1' : ''}>
              <p className="text-[10px] font-semibold text-muted-foreground uppercase tracking-widest mb-1.5 px-3 pt-3">
                {module?.title || 'Untitled Module'}
              </p>
              <div className="space-y-0.5">
                {module?.lessons?.map((lesson) => {
                  const isActive = lesson?.id === currentLesson?.id;
                  return (
                    <button
                      key={lesson?.id}
                      onClick={() => onLessonChange(lesson)}
                      className={`
                        w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-left transition-all duration-150
                        ${isActive ? 'bg-accent/10 ring-1 ring-accent/20' : 'hover:bg-muted/40'}
                      `}
                    >
                      <div className="flex-shrink-0">
                        {lesson?.completed ? (
                          <div className="w-6 h-6 bg-success rounded-full flex items-center justify-center shadow-sm">
                            <Icon name="Check" size={13} color="white" />
                          </div>
                        ) : (
                          <div
                            className={`w-6 h-6 rounded-full flex items-center justify-center border ${
                              isActive ? 'border-accent/40 bg-accent/10' : 'border-border bg-muted/50'
                            }`}
                          >
                            <Icon
                              name={LESSON_TYPE_ICONS?.[lesson?.type] || 'Circle'}
                              size={11}
                              className={isActive ? 'text-accent' : 'text-muted-foreground'}
                            />
                          </div>
                        )}
                      </div>
                      <h4
                        className={`text-sm font-medium truncate flex-1 ${
                          isActive ? 'text-accent' : 'text-foreground'
                        }`}
                      >
                        {lesson?.title}
                      </h4>
                    </button>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LessonNavigation;